import React, { useState, useEffect } from 'react';
import { FaTimes, FaPaperPlane, FaCheck, FaStar, FaUser, FaEnvelope, FaPhone, FaComment, FaShieldAlt } from 'react-icons/fa';
import { MdVerified } from 'react-icons/md';
import { sendHtmlEmail } from "../emailapi";

const EnquiryPopup = () => {
  const [isOpen, setIsOpen] = useState(true);
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    phone: '',
    subject: '',
    message: '',
    agreeTerms: false,
    receiveUpdates: false
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      await sendHtmlEmail("info@skkjewellers.com", "New Enquiry", formData);
      console.log('Form submitted:', formData);
      setIsSubmitted(true);

      setTimeout(() => {
        setIsSubmitted(false);
        setIsOpen(false);
        document.body.style.overflow = 'auto';
        setFormData({
          fullName: '',
          email: '',
          phone: '',
          subject: '',
          message: '',
          agreeTerms: false,
          receiveUpdates: false
        });
      }, 2000);

    } catch (error) {
      console.error("Email failed:", error);
      alert("Failed to send enquiry ❌");
    }
  };

  const handleClose = () => {
    setIsOpen(false);
    document.body.style.overflow = 'auto';
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop - responsive touch-friendly */}
      <div 
        className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-3 sm:p-4 md:p-6"
        onClick={handleClose}
      >
        {/* Modal Container - fully responsive */}
        <div 
          className="relative bg-white rounded-2xl shadow-2xl w-full max-w-[95%] sm:max-w-sm md:max-w-md lg:max-w-lg animate-slideUp overflow-y-auto max-h-[90vh] sm:max-h-[85vh]"
          onClick={(e) => e.stopPropagation()}
        >
          
          {/* Decorative Golden Border Top */}
          <div className="absolute top-0 left-0 right-0 h-1 bg-gradient-to-r from-amber-400 via-orange-500 to-amber-400 rounded-t-2xl"></div>
          
          {/* Header with Golden/Orange Gradient - Mobile optimized */}
          <div className="bg-gradient-to-r from-amber-500 via-orange-500 to-amber-600 text-white px-4 sm:px-5 py-3 sm:py-4 rounded-t-2xl sticky top-0 z-10">
            <div className="flex justify-between items-start">
              <div className="flex-1">
                <div className="flex items-center gap-1.5 sm:gap-2 mb-1">
                  <FaStar className="text-yellow-200 text-xs sm:text-sm" />
                  <h2 className="text-sm sm:text-base md:text-lg font-bold tracking-wide">Swarn Kala Kendra</h2>
                </div>
                <p className="text-[11px] sm:text-xs text-yellow-100">Get in Touch with Us</p>
              </div>
              <button 
                onClick={handleClose}
                className="hover:bg-white/20 p-1.5 sm:p-2 rounded-full transition-colors active:bg-white/30 min-w-[36px] min-h-[36px] flex items-center justify-center"
                aria-label="Close"
              >
                <FaTimes className="text-white text-sm sm:text-base" />
              </button>
            </div>
          </div>

          {/* Success Message - Mobile optimized */}
          {isSubmitted && (
            <div className="m-3 sm:m-4 bg-green-50 border border-green-200 rounded-lg p-2.5 sm:p-3 flex items-center gap-2">
              <div className="bg-gradient-to-r from-green-500 to-emerald-500 rounded-full p-1">
                <FaCheck className="text-white text-[10px] sm:text-xs" />
              </div>
              <p className="text-xs sm:text-sm font-semibold text-green-800">Enquiry Sent Successfully!</p>
            </div>
          )}

          {/* Form - Mobile friendly spacing */}
          <form onSubmit={handleSubmit} className="p-4 sm:p-5 space-y-3 sm:space-y-4">
            {/* Full Name */}
            <div>
              <label className="block text-gray-700 font-semibold text-xs sm:text-sm mb-1.5">
                Full Name <span className="text-orange-500">*</span>
              </label>
              <div className="relative">
                <FaUser className="absolute left-3 top-1/2 -translate-y-1/2 text-amber-400 text-xs sm:text-sm" />
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleChange}
                  required
                  className="w-full pl-9 sm:pl-10 pr-3 py-2 sm:py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-400/20 transition-all"
                  placeholder="Enter your full name"
                />
              </div>
            </div>

            {/* Email */}
            <div>
              <label className="block text-gray-700 font-semibold text-xs sm:text-sm mb-1.5">
                Email Address <span className="text-orange-500">*</span>
              </label>
              <div className="relative">
                <FaEnvelope className="absolute left-3 top-1/2 -translate-y-1/2 text-amber-400 text-xs sm:text-sm" />
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  className="w-full pl-9 sm:pl-10 pr-3 py-2 sm:py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-400/20 transition-all"
                  placeholder="your@email.com"
                />
              </div>
            </div>

            {/* Phone */}
            <div>
              <label className="block text-gray-700 font-semibold text-xs sm:text-sm mb-1.5">
                Phone Number <span className="text-orange-500">*</span>
              </label>
              <div className="relative">
                <FaPhone className="absolute left-3 top-1/2 -translate-y-1/2 text-amber-400 text-xs sm:text-sm" />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleChange}
                  required
                  className="w-full pl-9 sm:pl-10 pr-3 py-2 sm:py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-400/20 transition-all"
                  placeholder="089537 86652"
                />
              </div>
            </div>

            {/* Subject */}
            <div>
              <label className="block text-gray-700 font-semibold text-xs sm:text-sm mb-1.5">
                Select Subject <span className="text-orange-500">*</span>
              </label>
              <select
                name="subject"
                value={formData.subject}
                onChange={handleChange}
                required
                className="w-full px-3 py-2 sm:py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-400/20 transition-all bg-white"
              >
                <option value="">Select a subject</option>
                <option value="product">Gold Jewellery Inquiry</option>
                <option value="order">Order Status</option>
                <option value="returns">Returns & Exchange</option>
                <option value="feedback">Feedback</option>
                <option value="other">Other</option>
              </select>
            </div>

            {/* Message */}
            <div>
              <label className="block text-gray-700 font-semibold text-xs sm:text-sm mb-1.5">
                Your Message
              </label>
              <div className="relative">
                <FaComment className="absolute left-3 top-3 text-amber-400 text-xs sm:text-sm" />
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  rows="3"
                  className="w-full pl-9 sm:pl-10 pr-3 py-2 sm:py-2.5 text-sm sm:text-base border border-gray-300 rounded-lg focus:outline-none focus:border-amber-400 focus:ring-2 focus:ring-amber-400/20 transition-all resize-none"
                  placeholder="Tell us about your requirements..."
                ></textarea>
              </div>
            </div>

            {/* Checkboxes - Mobile optimized */}
            <div className="space-y-2.5 sm:space-y-3">
              <label className="flex items-start gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name="agreeTerms"
                  checked={formData.agreeTerms}
                  onChange={handleChange}
                  required
                  className="mt-0.5 w-3.5 h-3.5 sm:w-4 sm:h-4 text-amber-500 focus:ring-amber-400 border-gray-300 rounded"
                />
                <span className="text-[11px] sm:text-xs text-gray-700 leading-relaxed">
                  I agree to the <a href="/terms" className="text-amber-600 hover:underline font-medium">Terms & Conditions</a> and <a href="/privacy" className="text-amber-600 hover:underline font-medium">Privacy Policy</a>.
                </span>
              </label>
              
              <label className="flex items-start gap-2 cursor-pointer">
                <input
                  type="checkbox"
                  name="receiveUpdates"
                  checked={formData.receiveUpdates}
                  onChange={handleChange}
                  className="mt-0.5 w-3.5 h-3.5 sm:w-4 sm:h-4 text-amber-500 focus:ring-amber-400 border-gray-300 rounded"
                />
                <span className="text-[11px] sm:text-xs text-gray-600 leading-relaxed">
                  I would like to receive updates from Swarn Kala Kendra via Email, SMS, WhatsApp, and RCS.
                </span>
              </label>
            </div>

            {/* Submit Button - Mobile touch friendly */}
            <button
              type="submit"
              className="w-full bg-gradient-to-r from-amber-500 via-orange-500 to-amber-600 hover:from-amber-600 hover:via-orange-600 hover:to-amber-700 text-white font-semibold py-2.5 sm:py-3 px-4 rounded-lg transition-all duration-300 flex items-center justify-center gap-2 text-sm sm:text-base active:scale-98 transform"
            >
              <FaPaperPlane className="text-white text-xs sm:text-sm" />
              SEND ENQUIRY
            </button>

            {/* Trust Badge */}
            <div className="text-center pt-1 pb-1">
              <div className="flex items-center justify-center gap-1.5 flex-wrap">
                <FaShieldAlt className="text-gray-400 text-[10px] sm:text-xs" />
                <p className="text-[10px] sm:text-xs text-gray-400">Your information is safe with us</p>
                <MdVerified className="text-amber-400 text-[10px] sm:text-xs" />
              </div>
            </div>
          </form>

          {/* Decorative Bottom Border */}
          <div className="absolute bottom-0 left-0 right-0 h-0.5 bg-gradient-to-r from-amber-400 via-orange-500 to-amber-400 rounded-b-2xl"></div>
        </div>
      </div>

      <style>{`
        @keyframes slideUp {
          from {
            transform: translateY(30px);
            opacity: 0;
          }
          to {
            transform: translateY(0);
            opacity: 1;
          }
        }
        
        .animate-slideUp {
          animation: slideUp 0.3s ease-out;
        }

        /* Better touch targets for mobile */
        @media (max-width: 640px) {
          input, select, textarea, button {
            font-size: 16px !important;
          }
          
          button, a, [role="button"] {
            min-height: 44px;
          }
          
          input[type="checkbox"] {
            min-width: 18px;
            min-height: 18px;
          }
        }

        /* Active state for buttons on mobile */
        .active\\:scale-98:active {
          transform: scale(0.98);
        }
      `}</style>
    </>
  );
};

export default EnquiryPopup;